export default __webpack_public_path__ + "static/media/buy.70264429.svg";